/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { CreateOtherQaEquipmentDtoBrand1 } from './CreateOtherQaEquipmentDtoBrand1';
import {
    CreateOtherQaEquipmentDtoBrand1FromJSON,
    CreateOtherQaEquipmentDtoBrand1FromJSONTyped,
    CreateOtherQaEquipmentDtoBrand1ToJSON,
} from './CreateOtherQaEquipmentDtoBrand1';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { CreateOtherQaEquipmentDtoSingleDetectorConnectorType } from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import {
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON,
} from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface PtwQaEquipmentWithoutSerialNumberDto
 */
export interface PtwQaEquipmentWithoutSerialNumberDto {
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoBrand1}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    brand1?: CreateOtherQaEquipmentDtoBrand1 | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoSingleDetectorConnectorType}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    singleDetectorConnectorType?: CreateOtherQaEquipmentDtoSingleDetectorConnectorType | null;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    readonly isIotDevice?: boolean;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isCalibratable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    isZeroMeasurementConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithoutSerialNumberDto
     */
    $type?: PtwQaEquipmentWithoutSerialNumberDtoTypeEnum;
}


/**
 * @export
 */
export const PtwQaEquipmentWithoutSerialNumberDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoPtwQaEquipmentWithoutSerialNumberDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwQaEquipmentWithoutSerialNumberDtoTypeEnum = typeof PtwQaEquipmentWithoutSerialNumberDtoTypeEnum[keyof typeof PtwQaEquipmentWithoutSerialNumberDtoTypeEnum];



/**
 * Check if a given object implements the PtwQaEquipmentWithoutSerialNumberDto interface.
 */
export function instanceOfPtwQaEquipmentWithoutSerialNumberDto(value?: unknown): value is PtwQaEquipmentWithoutSerialNumberDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwQaEquipmentWithoutSerialNumberDtoTypeEnum)[0];
}

export function PtwQaEquipmentWithoutSerialNumberDtoFromJSON(json: any): PtwQaEquipmentWithoutSerialNumberDto {
    return PtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json, false);
}

export function PtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwQaEquipmentWithoutSerialNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'masterDeviceId': json['masterDeviceId'] == null ? undefined : json['masterDeviceId'],
        'withSerialNumber': json['withSerialNumber'] == null ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'brand1': json['brand1'] == null ? undefined : CreateOtherQaEquipmentDtoBrand1FromJSON(json['brand1']),
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'isIotDevice': json['isIotDevice'] == null ? undefined : json['isIotDevice'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': json['coordinateSystem'] == null ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': json['state'] == null ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'isCalibratable': json['isCalibratable'] == null ? undefined : json['isCalibratable'],
        'isZeroMeasurementConfigurable': json['isZeroMeasurementConfigurable'] == null ? undefined : json['isZeroMeasurementConfigurable'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwQaEquipmentWithoutSerialNumberDtoToJSON(value?: Omit<PtwQaEquipmentWithoutSerialNumberDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'|'deleterUserId'|'deletionTime'|'isDeleted'|'isIotDevice'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'typeSpecification': value['typeSpecification'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isArchived': value['isArchived'],
        'defaultImageId': value['defaultImageId'],
        'masterDeviceId': value['masterDeviceId'],
        'withSerialNumber': WithSerialNumberToJSON(value['withSerialNumber']),
        'typeNumber': value['typeNumber'],
        'brand1': CreateOtherQaEquipmentDtoBrand1ToJSON(value['brand1']),
        'singleDetectorConnectorType': CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryToJSON(value['subCategory']),
        'coordinateSystem': CoordinateSystemToJSON(value['coordinateSystem']),
        'state': QaEquipmentStateOfUseToJSON(value['state']),
        'isRegistrable': value['isRegistrable'],
        'isCalibratable': value['isCalibratable'],
        'isZeroMeasurementConfigurable': value['isZeroMeasurementConfigurable'],
        '$type': value['$type'],
    });
}

